<template>
    <div class="document-section">
        <h3 class="fs-16 font-weight-bold clr-title mb-4">Uploaded Documents</h3>

        <!-- SKELETON LOADER -->
        <div v-if="loading" class="row">
            <div class="col-md-6 col-lg-4 mb-4" v-for="n in 6" :key="n">
                <div class="ticket_documentInfo d-flex align-items-center gap-3 h-100">
                    <!-- Skeleton icon -->
                    <div class="icon-wrapper flex-shrink-0">
                        <b-skeleton type="avatar" width="34px" height="34px"></b-skeleton>
                    </div>

                    <div class="document_content d-flex flex-column gap-2 flex-grow-1">
                        <!-- Skeleton filename line -->
                        <b-skeleton width="80%" height="18px" style="border-radius: 4px !important;"></b-skeleton>

                        <!-- Skeleton meta info -->
                        <div class="d-flex align-items-center gap-2">
                            <b-skeleton width="40px" height="14px"></b-skeleton>
                            <b-skeleton width="60px" height="14px"></b-skeleton>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- REAL DOCUMENTS -->
        <div v-else class="row">
            <div class="col-md-6 col-lg-4 mb-4" v-for="document in documents" :key="document.id">
                <div class="ticket_documentInfo d-flex align-items-center gap-3 h-100">
                    <div class="icon-wrapper flex-shrink-0">
                        <img :src="getFileIcon(document.ext)" :alt="`${document.ext} icon`" class="w-100 h-100"/>
                    </div>

                    <div class="document_content d-flex flex-column gap-1 flex-grow-1">
                        <a 
                            :href="document.path" 
                            class="document_link d-flex align-items-center gap-1 justify-content-between"
                            target="_blank"
                            :title="`Click to view ${document.original_name}. Use browser's 'Save As' to download.`"
                        >
                            <span class="document_name clr-primary fs-16 fw-semibold">{{ document.original_name }}</span>
                            <span class="link_icon d-flex align-items-center justify-content-center clr-primary font-14">
                                <i class="fas fa-external-link-alt"></i>
                            </span>
                        </a>

                        <div class="document_info d-flex align-items-center gap-2 flex-wrap font-14">
                            <span class="document_type clr-bold-grey">{{ document.ext.toUpperCase() }}</span>
                            <span class="dots"> </span>
                            <span class="document_datewrapper clr-title fw-medium">
                                Uploaded :
                                <span class="document_date clr-bold-grey fw-normal">{{ document.created_at }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="documents.length===0" class="col-md-6 col-lg-4 mb-4">No Data</div>
        </div>

    </div>
</template>

<script>
import Api from "@/resource/Api";

export default {
    name: "TicketIssueDocument",
    data() {
        return {
            documents: [],
            loading: true,
            iconMap: {
                pdf: require('@/assets/images/pdf.svg'),
                doc: require('@/assets/images/file-regular-full.svg'),
                docx: require('@/assets/images/file-regular-full.svg'),
                xls: require('@/assets/images/excel.svg'),
                xlsx: require('@/assets/images/excel.svg'),
                png: require('@/assets/images/image-regular-full.svg'),
                jpg: require('@/assets/images/image-regular-full.svg'),
                jpeg: require('@/assets/images/image-regular-full.svg'),
                gif: require('@/assets/images/image-regular-full.svg'),
                txt: require('@/assets/images/file-regular-full.svg'),
            }
        };
    },
    created() {
        this.getDocuments();
    },
    methods: {
        getDocuments() {
            this.loading = true;

            const ticketId = this.$route.params.ticketId;

            Api.get(`tickets/${ticketId}/documents`)
                .then((res) => {
                    if(res.data.status==="success" && res.data?.data) {
                        this.documents = res.data.data;
                    }
                })
                .catch(err => console.error("API Error:", err))
                .finally(() => {
                    this.loading = false;
                });
        },
        getFileIcon(extension) {
            return this.iconMap[extension?.toLowerCase()] || this.iconMap.doc;
        },
    }
};
</script>

<style scoped>
    .icon-wrapper {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
